import React, { useEffect, useRef, useState } from 'react';
import { getUserPayments } from '../../../lib/api';
import './summary.css';
import { Link } from 'react-router-dom';

const Payments = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ total_pages: 1 });
  const [totals, setTotals] = useState({ credit: '0.00000', debit: '0.00000', refund: '0.00000' });
  const [hasMore, setHasMore] = useState(true);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const containerRef = useRef(null);
  const pageRef = useRef(1);
  const hasMoreRef = useRef(true);
  const loadingRef = useRef(false);

  const load = async (nextPage) => {
    if (loadingRef.current || !hasMoreRef.current) return;
    loadingRef.current = true;
    setLoading(true); 
    setError('');
    try {
      const resp = await getUserPayments(nextPage, 30);
      const list = resp?.data || resp?.payments || [];
      setRows((prev) => [...prev, ...list]);
      setPagination(resp?.pagination || { total_pages: 1 });
      if (resp?.totals) setTotals(resp.totals);
      if (list.length < 10) {
        hasMoreRef.current = false;
        setHasMore(false);
      }
      if (isInitialLoad) setIsInitialLoad(false);
      pageRef.current = nextPage;
      setPage(nextPage);
    } catch (e) {
      setError(e?.message || 'Failed to load payments');
    } finally { 
      loadingRef.current = false;
      setLoading(false); 
    }
  };

  const onScroll = () => {
    const el = containerRef.current;
    if (!el || loadingRef.current || !hasMoreRef.current) return;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 60;
    if (nearBottom) {
      const next = pageRef.current + 1;
      load(next);
    }
  };

  useEffect(() => { 
    pageRef.current = 1;
    hasMoreRef.current = true;
    load(1); 
  }, []);

  return (
    <div className="summary-wrap">
      <div className="summary-header">
        <h2>Payments</h2>
        <div className="summary-meta">{rows.length} loaded</div>
      </div>
      {error && <div className="error" style={{ marginBottom: 8 }}>{error}</div>}
      {rows.length > 0 && (
        <div className="totals-row">
          <div className="total-pill credit">Total Credit: ₹{totals.credit}</div>
          <div className="total-pill debit">Total Debit: ₹{totals.debit}</div>
          <div className="total-pill refund">Total Refund: ₹{totals.refund}</div>
        </div>
      )}
      <div ref={containerRef} className="summary-scroll" onScroll={onScroll}>
        <div className="summary-table-wrap">
          <table className="summary-table">
            <thead>
              <tr>
                <th>Payment ID</th>
                <th>Method</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Campaign ID</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {isInitialLoad && loading ? (
                Array.from({length:8}).map((_,i)=> (
                  <tr key={`sk-${i}`} className="skeleton-row">
                    <td><div className="sk sk-text" /></td>
                    <td><div className="sk sk-text" /></td>
                    <td><div className="sk sk-pill" /></td>
                    <td><div className="sk sk-text" /></td>
                    <td><div className="sk sk-text" /></td>
                    <td><div className="sk sk-text long" /></td>
                  </tr>
                ))
              ) : (
                <>
                  {rows.length ? rows.map((p, idx) => (
                    <tr key={idx}>
                      <td>{p.payment_id || '—'}</td>
                      <td>{p.payment_method || '—'}</td>
                      <td>{p.transaction_type || '—'}</td>
                      <td>₹{p.amount != null ? Number(p.amount).toFixed(5) : '—'}</td>
                      <td>
                        {p.campaign_id ? (
                          <Link to={`/main/template-report?campaign_id=${p.campaign_id}`} className="campaign-link">
                            {p.campaign_id}
                          </Link>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td>{p.payment_date ? new Date(p.payment_date).toLocaleString() : '—'}</td>
                    </tr>
                  )) : (
                    <tr><td colSpan={6} className="empty-cell">No payments found</td></tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        {!isInitialLoad && loading && (
          <div className="summary-loading-bottom">
            <div className="loading-spinner-small"></div>
            <span>Loading more...</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Payments;
